import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Shield, Radio } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const ComingSoon = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/subscribe", { email });
      toast.success(data.already ? "Already on the list" : "You're on the list", { description: data.message });
      if (!data.already) setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not subscribe");
    } finally {
      setBusy(false);
    }
  };

  const utc = now.toISOString().slice(0, 19).replace("T", " ");

  return (
    <div className="bg-masthead text-masthead-ink min-h-screen flex flex-col relative overflow-hidden grain-overlay" data-testid="coming-soon">
      {/* ticker */}
      <div className="border-b border-white/10 overflow-hidden">
        <div className="ticker-track py-2">
          {Array.from({ length: 8 }).map((_, i) => (
            <span key={i} className="font-mono2 text-[0.65rem] tracking-[0.25em] px-6 flex items-center text-masthead-ink/70">
              <span className="text-signal mr-2">●</span> TRANSMISSION INCOMING — ARCHIVE UNDER CONSTRUCTION
            </span>
          ))}
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-2xl w-full text-center fade-up">
          <div className="overline-label text-signal mb-6 flex items-center justify-center gap-2">
            <Radio size={14} /> EST. 2026 — CLASSIFIED ARCHIVE
          </div>
          <h1 className="font-display font-black text-5xl sm:text-7xl lg:text-8xl tracking-tight leading-[0.95]">
            DISCLOSURE<br />JOURNAL
          </h1>
          <p className="font-body italic text-masthead-ink/70 text-lg sm:text-xl mt-5">
            They're here. Keep up.
          </p>

          <div className="w-16 h-px bg-signal mx-auto my-10" />

          <h2 className="font-display text-2xl sm:text-3xl font-bold">The archive is being assembled.</h2>
          <p className="font-body text-masthead-ink/60 text-base sm:text-lg mt-4 max-w-lg mx-auto leading-relaxed">
            We're gathering the most credible reporting, testimony and documentary evidence on UAP, UFO, NHI and full disclosure. Leave your signal below and be first through the door when we go live.
          </p>

          <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              data-testid="coming-soon-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              className="flex-1 bg-transparent border border-white/25 px-4 py-3 font-mono2 text-sm text-masthead-ink placeholder:text-masthead-ink/40 focus:outline-none focus:border-signal"
            />
            <button
              data-testid="coming-soon-submit"
              type="submit"
              disabled={busy}
              className="bg-signal text-white font-mono2 text-xs uppercase tracking-[0.2em] px-6 py-3 hover:opacity-90 disabled:opacity-50 whitespace-nowrap"
            >
              {busy ? "…" : "Notify Me"}
            </button>
          </form>

          <div className="mt-12 font-mono2 text-[0.65rem] tracking-[0.2em] text-masthead-ink/40">
            {utc} UTC — STANDBY
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-5 px-4 flex items-center justify-between">
        <span className="font-mono2 text-[0.6rem] tracking-[0.2em] text-masthead-ink/40 uppercase">© 2026 DisclosureJournal</span>
        <Link to="/login" data-testid="coming-soon-admin" className="font-mono2 text-[0.6rem] tracking-[0.2em] text-masthead-ink/40 uppercase hover:text-signal flex items-center gap-1">
          <Shield size={11} /> Editor Access
        </Link>
      </div>
    </div>
  );
};

export default ComingSoon;
